import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';

import DatasetAlternateLabelView from './DatasetAlternateLabelView';
import DatasetComponentNote from './DatasetComponentNote';

interface DatasetNoComponentViewProps {
    datasetId: number;
    datasetName: string;
    datasetField: number;
    columnNameMapping: Record<number, string>;
    wrapText?: boolean;
}

const DatasetNoComponentView: FC<DatasetNoComponentViewProps> = ({
    datasetId,
    datasetName,
    columnNameMapping,
    datasetField,
    wrapText,
}) => {
    return (
        <Container>
            <HeaderTextContainer>
                <HeaderText>{datasetName}</HeaderText>
            </HeaderTextContainer>
            <HeaderContainer>
                <HeaderText>
                    {columnNameMapping[datasetField]}{' '}
                    <AlternateLabelTag>Alternate</AlternateLabelTag>
                </HeaderText>
            </HeaderContainer>
            <DatasetAlternateLabelView
                datasetId={datasetId}
                datasetField={datasetField}
                showLabels={false}
                wrapText={wrapText}
            />
            <DatasetComponentNote
                datasetId={datasetId}
                note={'Dataset alternates cannot be edited here.'}
            />
        </Container>
    );
};

const Container = styled.div({
    width: '500px',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    border: `1px solid ${aampeTheme.colors.interactiveWG01}`,
});

const HeaderContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    borderBottom: `0px`,
    cursor: 'pointer',
});

const HeaderTextContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    backgroundColor: aampeTheme.colors.backgroundWG02,
    '&:hover': {
        backgroundColor: aampeTheme.colors.backgroundWG02,
    },
});

const HeaderText = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(4),
    padding: aampeTheme.spacing4(2, 4),
    fontSize: aampeTheme.size.font.textMedium,
    lineHeight: '24px',
    fontWeight: 500,
    color: aampeTheme.colors.textAccessibleWG01,
    width: '100%',
    overflow: 'hidden',
    height: '43px',
    backgroundColor: 'inherit',
    borderBottom: '0px',
    borderLeft: '0px',
});

const AlternateLabelTag = styled.span({
    borderRadius: aampeTheme.spacing4(1),
    padding: aampeTheme.spacing4(0.5, 1),
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    color: aampeTheme.colors.textAccessibleWG01,
});

export default DatasetNoComponentView;
